<!-- Only a "real" link if you're logged in, otherwise, opens a signup dialog first -->
<template>
  <a
    @click="!isLoggedIn && $event.preventDefault() || onClick()"
    :href="redirectUrl"
    :class="'plausible-event-name=' + trackingEventName.replace(/\s/g, '+')"
    :style="hasButton && 'text-decoration: none'"
    >
    <slot></slot>
  </a>
</template>

<script lang="ts">
import { Vue, Component, Model, Prop } from 'vue-property-decorator'
import userStore from '@/modules/users/store'
import { lassoxPortalUrl } from '@/lasso-urls'
import LoginDialogTemplateOptions from './LoginDialogTemplate/options'

@Component({})

export default class LassoxLink extends Vue {

  // latter part of plausible link, e.g. 'news+teaser+signup'
  @Prop({ type: String, required: true })
  readonly trackingEventName!: string
  @Prop({ type: String, required: true })
  readonly path!: string
  @Prop({ type: String, required: false, default: 'entity' })
  readonly appType!: 'entity' | 'standalone'
  @Prop({ type: String, required: false, default: 'signup' })
  readonly initialRoute!: 'signup' | 'login'
  @Prop({ type: Object, required: false })
  readonly dialogOptions?: LoginDialogTemplateOptions

  get isLoggedIn() {
    return !!userStore.user
  }

  get hasButton() {
    return !!this.$slots?.default?.filter(node => node.componentOptions?.tag === 'Button').length
  }

  get redirectUrl() {
    const entityPrefix = this.$route.meta?.lassoIdPrefixes
    return `${lassoxPortalUrl + '/'
      + (entityPrefix && this.appType === 'entity' ? entityPrefix + this.$route.params.id : 'app' )
      + '/' + this.path}
    `
  }

  onClick() {
    userStore.showLoginDialog({
      redirectUrl: this.redirectUrl,
      initialRoute: this.initialRoute,
      ...this.dialogOptions,
      trackingEventName: this.trackingEventName
    })
  }
}
</script>